import React, { Component, Fragment } from 'react';
import * as types from '../../constants/actionTypes';
import PropTypes from 'prop-types'
import Drawer from '../Common/Drawer/Drawer';
import Notification from '../Common/Notification';
import InputText from '../Common/InputText';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import './TaskListPage/TaskListPage.scss'

export class BulkUpdateResponsibleUserDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isSaving: false,
            users: this.props.responsibleUsers,
            resultUsers: this.props.responsibleUsers,
            selectedUser: "",
            searchTerm: "",
            isFormValid: true,
            isSearching: false,
            assignedToMe: false
        }
    }

    searchUsers = () => {
        this.setState({ isSearching: true });

        const { users, searchTerm } = this.state;

        if (users) {
            if (searchTerm) {
                const lowerSearchTerm = searchTerm.toLowerCase();
                const resultUsers = users.filter(l => l.name.toLowerCase().indexOf(lowerSearchTerm) > -1);

                this.setState({
                    ...this.state,
                    resultUsers
                });
            } else {
                //return all users if search term is falsey
                this.setState({
                    ...this.state,
                    resultUsers: users
                });
            }
        }
        this.setState({ isSearching: false });
    }

    updateSearchTerm = (e) => {
        this.setState({ searchTerm: e.currentTarget.value}, () => this.searchUsers());
    }

    selectUser = (e) => {
        const selectedUser = this.state.users.find(m => m.id === parseInt(e.currentTarget.value));
        this.setState({ selectedUser: selectedUser });
    }

    onSave = async () => {
        if(!this.state.selectedUser){
            this.setState({ isFormValid: false });
            return;
        }

        let taskIds = this.props.locationTasks.map(m => m.id);

        try {
            const response = await this.props.locationTaskActions.updateResponsibleUser(taskIds, this.state.selectedUser.id);
            if (response.type === types.UPDATE_LOCATION_TASK_LIST_RESPONSIBLE_USER_SUCCESS) {

                Notification("success", "Location Tasks Updated", "Responsible User has been set");
                this.props.onComplete();

            } else if (response.type === types.UPDATE_LOCATION_TASK_LIST_RESPONSIBLE_USER_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        }
    }

    onAssignToMe = () => {
        const selectedUser = { id: this.props.userId, Name: "" };
        this.setState({ assignedToMe: true, selectedUser: selectedUser });
    }

    onCancelAssignToMe = () => {
        this.setState({ assignedToMe: false, selectedUser: "" });
    }

    render() {

        return (
            <Drawer isOpen={true} isWide={false} title='Update Responsible User'
                onSaveClick={this.onSave}
                saveText='Save'
                onCancelClick={this.props.onCancel}>
                <Fragment>
                    { this.state.selectedUser.id == this.props.userId && this.state.assignedToMe ?
                    
                        <div>
                            <p>These Tasks will be assigned to <u>you</u></p>
                            <span className="task-name" onClick={this.onCancelAssignToMe}>Choose someone else</span>
                        </div>
                    :
                        <Fragment>
                            <div>
                                <span className="task-name" onClick={this.onAssignToMe}>Assign Tasks to Me</span>
                                <br /><br />
                                <p>Or</p>
                            </div> 
                            <InputText
                                type="text"
                                name="search"
                                label="User Search"
                                placeholder="Type a name here and press enter to search"
                                value={this.state.searchTerm}
                                onChange={this.updateSearchTerm}
                                maxLength={20}
                            />

                            <LoadingIndicator isLoading={this.state.isSearching}>
                                <form noValidate className={this.state.isFormValid ? "" : "was-validated"}>
                                    <div className="mb-3">
                                        <span className="has-float-label">
                                            <select name="searchResults" size={10} className="form-control user-select" onClick={this.selectUser} required={true}>
                                                {this.state.resultUsers.map(user =>
                                                    <option key={user.id} value={user.id}>{user.name}</option>
                                                )}
                                            </select>
                                            <label htmlFor="searchResults">Search Results</label>
                                            <div className="invalid-feedback">Choose a User</div>
                                        </span>
                                    </div> 
                                </form>                
                            </LoadingIndicator>  
                        </Fragment>

                    }
                  
                </Fragment>


            </Drawer>
        )
    }
}

BulkUpdateResponsibleUserDrawer.propTypes = {
    locationTaskActions: PropTypes.object.isRequired,
    responsibleUsers: PropTypes.array.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    locationKeys: PropTypes.array,
    locationTasks: PropTypes.array,
    userId: PropTypes.number.isRequired
};


export default BulkUpdateResponsibleUserDrawer;
